module.exports = __webpack_public_path__ + "static/manifest.ce60f467.webmanifest";